import { createFileRoute } from '@tanstack/react-router';

import { FinalReviewView } from '@/features/gap-review/components/FinalReviewView';

export const Route = createFileRoute('/_dashboard/gap-review/final')({
  component: FinalReviewView,
});
